/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SurfaceCodeEntryConfig
 */
export interface SurfaceCodeEntryConfig {
    /**
     * CTA headline (e.g. "Enter Your Code")
     * @type {string}
     * @memberof SurfaceCodeEntryConfig
     */
    headline?: string;
    /**
     * 
     * @type {string}
     * @memberof SurfaceCodeEntryConfig
     */
    description?: string;
    /**
     * Button label (e.g. "ENTER CODE")
     * @type {string}
     * @memberof SurfaceCodeEntryConfig
     */
    buttonText?: string;
    /**
     * Quest config to validate codes against
     * @type {string}
     * @memberof SurfaceCodeEntryConfig
     */
    questConfigId?: string;
    /**
     * Specific milestone within the quest for code entry
     * @type {string}
     * @memberof SurfaceCodeEntryConfig
     */
    milestoneId?: string;
}

/**
 * Check if a given object implements the SurfaceCodeEntryConfig interface.
 */
export function instanceOfSurfaceCodeEntryConfig(value: object): value is SurfaceCodeEntryConfig {
    return true;
}

export function SurfaceCodeEntryConfigFromJSON(json: any): SurfaceCodeEntryConfig {
    return SurfaceCodeEntryConfigFromJSONTyped(json, false);
}

export function SurfaceCodeEntryConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): SurfaceCodeEntryConfig {
    if (json == null) {
        return json;
    }
    return {
        
        'headline': json['headline'] == null ? undefined : json['headline'],
        'description': json['description'] == null ? undefined : json['description'],
        'buttonText': json['buttonText'] == null ? undefined : json['buttonText'],
        'questConfigId': json['questConfigId'] == null ? undefined : json['questConfigId'],
        'milestoneId': json['milestoneId'] == null ? undefined : json['milestoneId'],
    };
}

export function SurfaceCodeEntryConfigToJSON(json: any): SurfaceCodeEntryConfig {
    return SurfaceCodeEntryConfigToJSONTyped(json, false);
}

export function SurfaceCodeEntryConfigToJSONTyped(value?: SurfaceCodeEntryConfig | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'headline': value['headline'],
        'description': value['description'],
        'buttonText': value['buttonText'],
        'questConfigId': value['questConfigId'],
        'milestoneId': value['milestoneId'],
    };
}

